globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalSetupFormSubmission = (function(superClass) {
  globalThis.utils.extend(ModalSetupFormSubmission, superClass);

  function ModalSetupFormSubmission($html) {
    return ModalSetupFormSubmission.__super__.constructor.apply(this, arguments);
  }

  ModalSetupFormSubmission.prototype.init = function() {
    this.initContent();
    return ModalSetupFormSubmission.__super__.init.apply(this, arguments);
  };

  ModalSetupFormSubmission.prototype.initContent = function() {
    this.$html.find('.styled').uniform({ radioClass: 'choice' });
  };

  ModalSetupFormSubmission.prototype.bindSubmit = function() {
    this.$html.find('button.submit').click((function(_this) {
      return function() {
        backoffice.loader.start();
        _this.submit();
        return false;
      };
    })(this));
  };

  ModalSetupFormSubmission.prototype.callbackSuccess = function(data) {
    if (!data || !data.response) {
      backoffice.loader.finish();
      return;
    }

    if (data.reload) {
      window.location.reload();
      return;
    }

    backoffice.loader.finish();
    this.$html.find('.modal-content').replaceWith($(data.html).find('.modal-content'));
    this.initContent();
    this.bindSubmit();
  };

  return ModalSetupFormSubmission;

})(backoffice.ModalMain);
